import axios from "axios";
import { CMS_API_ENDPOINT } from "../constants/api-constants";
import { CaptainsData, CMSCaptain } from "../types/CMS";
import { Captain } from "../types/Captain";

export async function fetchCaptains(): Promise<CaptainsData> {
    try {
        const response = await axios.get(`${CMS_API_ENDPOINT}/captains-wall?sort=createdAt&limit=300`);
        return response.data;
    } catch (error) {
        throw new Error(`Failed to fetch captains data: ${error}`);
    }
}

export function transformCMSCaptainToAppCaptain(cmsCaptain: CMSCaptain): Captain {
    const baseUrl = CMS_API_ENDPOINT.replace("/api", "");

    const imageUrl = cmsCaptain.image
        ? `${baseUrl}${cmsCaptain.image.url}`
        : "";

    const videoUrl = cmsCaptain.video
        ? `${baseUrl}${cmsCaptain.video.url}`
        : "";

    const overviewImageUrl = cmsCaptain.overviewImage
        ? `${baseUrl}${cmsCaptain.overviewImage.url}`
        : imageUrl;

    return {
        firstName: cmsCaptain.firstName,
        lastName: cmsCaptain.lastName,
        position: cmsCaptain.position,
        yearOfActivity: cmsCaptain.yearOfActivity,
        yearsAsCaptain: cmsCaptain.yearsAsCaptain,
        imageUrl,
        videoUrl,
        overviewImageUrl,
        keyDetails: cmsCaptain.keyDetails || [],
        statistics: cmsCaptain.statistics || [],
        route: cmsCaptain.route,
    };
}